// extracted by mini-css-extract-plugin
export default {"MenuButton":"menu-button_MenuButton__Hh7Yc","active":"menu-button_active__wwB5S"};